const t = {
  name: "Tablet",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.25 5C13.25 5.69 12.69 6.25 12 6.25C11.31 6.25 10.75 5.69 10.75 5C10.75 4.31 11.31 3.75 12 3.75C12.69 3.75 13.25 4.31 13.25 5Z" fill="currentColor"/>
<path d="M5 0C3.34315 0 2 1.34315 2 3V21C2 22.6569 3.34315 24 5 24H19C20.6569 24 22 22.6569 22 21V3C22 1.34315 20.6569 0 19 0H5ZM4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Tablet
};
